<div class="row mt-5">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h5 class="mb-0 mt-0" translate>DEBTOR_MANDATES</h5>

      <gung-button
        classes="btn btn-primary"
        label="{{ 'CREATE_NEW_MANDATE' | translate }}"
        [onClick]="createNewMandate.bind(this)"
      />
    </div>

    <span class="font-italic small mb-2 d-inline-block" translate>
      DEBTOR_MANDATES_DESCRIPTION
    </span>
  </div>
</div>

<lib-filter-list #sepaMandateList [configService]="sepaMandatesListConfigService"></lib-filter-list>
